import { useParams } from "react-router";
import _ from "lodash";

import { URLS } from "config/urls";
import { ArrowBackIcon, ArrowForwardOutlinedIcon } from "icons";
import { colors } from "theme/palette";
import { reverse } from "utils/urls";

import Button from "components/Button";
import Link from "components/Link";
import Stack from "components/Stack";
import Text from "components/Text";

import {
  IPackageTab,
  useCompanyPackageWithTabsInformation,
} from "entities/Package/sdk";

export interface IFooter {
  onChecklistSubmitDialogOpen: () => void;
  isSubmittable: boolean;
  selectedTab?: IPackageTab;
}

const Footer = ({
  selectedTab,
  onChecklistSubmitDialogOpen,
  isSubmittable,
}: IFooter) => {
  const params = useParams<{
    dealId: string;
    packageId: string;
    tabId?: string;
  }>();
  const dealId = Number(params.dealId);
  const packageId = Number(params.packageId);
  const tabId: number | undefined = params.tabId
    ? Number(params.tabId)
    : undefined;
  const { data: checklist } = useCompanyPackageWithTabsInformation({
    dealId,
    packageId,
  });
  const previousTabId =
    checklist?.tabs[
      _.findIndex(checklist?.tabs, {
        id: tabId,
      }) - 1
    ]?.id;

  const nextTabId =
    checklist?.tabs[
      _.findIndex(checklist?.tabs, {
        id: tabId,
      }) + 1
    ]?.id;

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      paddingY={2}
      paddingX={2.5}
      borderRadius="8px"
      sx={{ backgroundColor: colors.blue10 }}
    >
      <Stack direction="row" gap={5} flexGrow={1}></Stack>

      <Stack marginLeft={2} gap={1} direction="row">
        {!_.isUndefined(previousTabId) && (
          <Link
            replace
            to={reverse(URLS.DEAL_PACKAGE, {
              dealId,
              packageId,
              // The previous tab compared to the current one
              tabId: previousTabId.toString(),
            })}
          >
            <Button
              variant="outlined"
              sx={{ color: colors.black }}
              data-testid="previous-tab-button"
            >
              <ArrowBackIcon
                sx={{
                  width: "20px",
                  height: "20px",
                  marginRight: 0.5,
                }}
              />
              <Text variant="text2" fontWeight={500}>
                Previous tab
              </Text>
            </Button>
          </Link>
        )}
        {!_.isUndefined(nextTabId) ? (
          <Link
            replace
            to={reverse(URLS.DEAL_PACKAGE, {
              dealId,
              packageId,
              // The next tab compared to the current one
              tabId: nextTabId.toString(),
            })}
          >
            <Button
              variant="outlined"
              sx={{ color: colors.black }}
              data-testid="next-tab-button"
            >
              <Text variant="text2" fontWeight={500}>
                Continue to next tab{" "}
              </Text>
              <ArrowForwardOutlinedIcon
                sx={{
                  width: "20px",
                  height: "20px",
                  marginLeft: 0.5,
                }}
              />
            </Button>
          </Link>
        ) : (
          isSubmittable && (
            <Button onClick={onChecklistSubmitDialogOpen}>
              <Text variant="text2" fontWeight={500}>
                Submit checklist
              </Text>
            </Button>
          )
        )}
      </Stack>
    </Stack>
  );
};
export default Footer;
